import React, { useState, useEffect } from 'react';
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds } from "../../Ads";
import imageUrl from "../../../images/eid-adha.webp";
import BlinkingText from '../../BlinkingText';
import RelatedLinks from '../RelatedLinks';
import MainCalculatorsList from './MainCalculators';
const TITLE = "كم باقي على رأس السنة الهجرية 2026 - العد التنازلي على رأس السنة الهجرية";
const DESCRIPTION = "كم باقي على رأس السنة الهجرية 1446، موعد رأس السنة الهجرية 1446، متى رأس السنة الهجرية، تاريخ رأس السنة الهجرية 1446، متى تكون رأس السنة الهجرية 1446، الاحتفال برأس السنة الهجرية، التهاني برأس السنة الهجرية، كم باقي على رأس السنة الهجرية 1446، تاريخ رأس السنة الهجرية، رأس السنة الهجرية في التقويم الهجري، متى يصادف رأس السنة الهجرية 1446، الأعمال المستحبة في رأس السنة الهجرية، كم باقي على رأس السنة الهجرية، رأس السنة الهجرية 1446 هجري، كم يوم باقي على رأس السنة الهجرية 1446، تاريخ رأس السنة الهجرية، متى رأس السنة الهجرية هذا العام، الاحتفال برأس السنة الهجرية، موعد رأس السنة الهجرية في 2026";
const KEYWORDS = "كم باقي على رأس السنة الهجرية 1446، موعد رأس السنة الهجرية 1446، متى رأس السنة الهجرية، تاريخ رأس السنة الهجرية 1446، متى تكون رأس السنة الهجرية 1446، الاحتفال برأس السنة الهجرية، التهاني برأس السنة الهجرية، كم باقي على رأس السنة الهجرية 1446، تاريخ رأس السنة الهجرية، رأس السنة الهجرية في التقويم الهجري، متى يصادف رأس السنة الهجرية 1446، الأعمال المستحبة في رأس السنة الهجرية، كم باقي على رأس السنة الهجرية، رأس السنة الهجرية 1446 هجري، كم يوم باقي على رأس السنة الهجرية 1446، تاريخ رأس السنة الهجرية، متى رأس السنة الهجرية هذا العام، الاحتفال برأس السنة الهجرية، موعد رأس السنة الهجرية في 2026";
const OG_URL = "https://do-calculate.com/articles-ar/hijri/";
function RaasSanaHijriya() {
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        }
        return timeLeft;
    };
    const initialDate = new Date("2026-06-27T00:00:00");
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(initialDate));
    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(initialDate));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft]);
    const hijriDates = [
        { name: 'رأس السنة الهجرية 2026', date: new Date("2026-06-27T00:00:00") },
        { name: 'رأس السنة الهجرية 2026', date: new Date("2026-06-17T00:00:00") },
        { name: 'رأس السنة الهجرية 2027', date: new Date("2027-06-06T00:00:00") },
        { name: 'رأس السنة الهجرية 2028', date: new Date("2028-05-25T00:00:00") },
        { name: 'رأس السنة الهجرية 2029', date: new Date("2029-05-15T00:00:00") },
    ];
    return (
        <div className="rtl">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className='p-3 mb-2 bg-success text-white'>
                كم باقي على رأس السنة الهجرية 1446
            </h1>
            <div>
                <BlinkingText text="كم باقي على رأس السنة الهجرية 1446: من المتوقع أن يبدأ رأس السنة الهجرية 1446 يوم الجمعة بتاريخ 27/06/2027 ميلادي و01 محرم 1446 بحسب التقويم الهجري." />
            </div>
            <div className="row">
                <div id="timer" style={{ width: '100%', fontSize: '40px' }}>
                                        <table style={{ width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '1px solid #ccc', fontSize: '24px' }}>
                        <thead>
                            <tr>
                                <th >يوم</th>
                                <th >ساعة</th>
                                <th >دقيقة</th>
                                <th >ثوانٍ</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td id="days">{timeLeft.days}</td>
                                <td id="hours">{timeLeft.hours}</td>
                                <td id="minutes">{timeLeft.minutes}</td>
                                <td id="seconds">{timeLeft.seconds}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div>
                        <h2 className='p-3 mb-2 bg-success text-white' style={{ color: '#333', fontSize: '36px', textAlign: 'center' }}>مواعيد رأس السنة الهجرية القادمة</h2>
                        <table style={{ fontSize: '24px', width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '2px solid #ccc', borderRadius: '8px', overflow: 'hidden' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f2f2f2' }}>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>موعد رأس السنة الهجرية</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>التاريخ</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>باقي</th>
                                </tr>
                            </thead>
                            <tbody>
                                {hijriDates.map((date, index) => (
                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                        <td style={{ padding: '12px' }}>{date.name}</td>
                                        <td style={{ padding: '12px' }}>{date.date.toLocaleDateString('en-GB')}</td>
                                        <td style={{ padding: '12px' }}>{calculateTimeLeft(date.date).days} يوم</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col">
                    <MainCalculatorsList />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className='p-3 mb-2 bg-success text-white'>كم باقي على رأس السنة الهجرية</h3>
                    <p>
                        في هذا المقال، نقدم لكم العد التنازلي المفصل لرأس السنة الهجرية، لتكونوا على اطلاع دائم بكم يوم باقٍ على وصول هذه المناسبة الدينية. الكثير منا يتسائلون كم باقي على رأس السنة الهجرية، لهذا نقدم لكم في هذا المقال العد التنازلي لرأس السنة الهجرية لتتمكنوا من معرفة كم باقي على رأس السنة الهجرية، كم يوم باقي على رأس السنة الهجرية، شاهدوا العد التنازلي لرأس السنة الهجرية في الأعلى.
                    </p>
                    <p>
                        وفقا لموقع <a href='/calculator/ar/gregorian_to_hijri/'>تحويل التاريخ</a> يصادف رأس السنة الهجرية 1446 يوم الجمعة بتاريخ 27/06/2027 ميلادي و01 محرم 1446 بحسب التقويم الهجري، يمكنكم مشاهدة العد التنازلي لرأس السنة الهجرية 1446 في هذا المقال.
                    </p>
                    <p>تجدون هنا العد التنازلي لرأس السنة الهجرية حيث يمكنكم معرفة كم باقي يوم على رأس السنة الهجرية.
                    </p>
                    <hr />
                    <RelatedLinks />
                    <hr />
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        احسب كم باقي لرأس السنة الهجرية
                    </h3 >
                    <p>
                        من خلال برنامج حساب العد التنازلي لرأس السنة الهجرية يمكنكم معرفة كم باقي لرأس السنة الهجرية بالتقويم الميلادي والهجري، كما يمكنكم معرفة باقي على رأس السنة الهجرية كم يوم، وكم تبقى لرأس السنة الهجرية، كم تبقى لرأس السنة الهجرية بالأيام، ومتى رأس السنة الهجرية العد التنازلي، باقي على رأس السنة الهجرية، كم تبقى على رأس السنة الهجرية، كم باقي عن رأس السنة الهجرية، باقي كم يوم على رأس السنة الهجرية، كم باقي عن رأس السنة الهجرية، كم تبقى لرأس السنة الهجرية، كم متبقي على رأس السنة الهجرية، كم يوم باقي لرأس السنة الهجرية، كم يوم على رأس السنة الهجرية، كم بقي على رأس السنة الهجرية، كم باقي على رأس السنة الهجرية، باقي كام يوم على رأس السنة الهجرية، وموعد رأس السنة الهجرية المباركة لهذه السنة، كل عام وأنتم بخير وأعاده الله علينا وعليكم باليمن والبركات.
                    </p>
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        رأس السنة الهجرية
                    </h3>
                    <p>
                        رأس السنة الهجرية هو بداية العام الهجري الجديد في التقويم الإسلامي، ويحتفل به المسلمون في أول يوم من شهر محرم كل عام هجري. يعتبر هذا اليوم من المناسبات الدينية الهامة التي يحييها المسلمون بالدعاء والتفكر في السنة الماضية والتخطيط للسنة الجديدة. يتميز هذا اليوم بأهمية خاصة في التاريخ الإسلامي لأنه يرمز إلى الهجرة النبوية من مكة إلى المدينة، والتي تشكل بداية التقويم الإسلامي.
                    </p>
                    <div>
                        <br />
                        <img src={imageUrl} alt="كم باقي على رأس السنة الهجرية 2026"
                            width="800"
                            height="450"
                            style={{ width: '100%', height: 'auto', maxWidth: '800px' }}
                            loading="lazy"
                        />
                        <br />
                    </div>
                </div>
            </div>
        </div>
    );
}
export default RaasSanaHijriya;
